module.exports = __webpack_public_path__ + "static/media/traffic.b181bd0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/traffic.jpg
// module id = 41
// module chunks = 0